import React from "react";
import Radio from '@material-ui/core/Radio';
import Grid from '@material-ui/core/Grid';
import { makeStyles,withStyles } from "@material-ui/core/styles";
import  '../assets/css/cardcomponent.css'
import Card from "@material-ui/core/Card";


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    card: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));
export default function PackageSubCard(props) {
    const classes = useStyles();
    
    const [selectedValue, setSelectedValue] = React.useState(props.structure[0].subId+'');
    const handleChange = (event) => {
     

      setSelectedValue(event.target.value);
      props.onClick(event);

    };
    function PackageSubCard(struct) {
      const classes = useStylesForCard();
      const structure=struct.structure;
     
    return(
          <Card className={classes.root}>
              <GreenRadio
                checked={selectedValue === structure.subId+''}
                onChange={handleChange}
                value={structure.subId+''}
                name="radio-button"
                inputProps={{ 'aria-label': 'A' }}
             />
              <img src={structure.image}alt="packageIcon"/> 
              <h6>{structure.pac}</h6>
              <h7>₹{structure.price}</h7>
              
           </Card>   
      );
      
  }
  
  const subPackageList = props.structure.map((packag) => {
    return (
          <Grid item xs={12} sm={6} md={4}>
              <PackageSubCard structure={packag}/>
           </Grid>
    );
});
  return (
    <div>
          <Grid container spacing={3} justify="center">
            {subPackageList}
          </Grid>   
            
    </div>
        
  );
}
const useStylesForCard = makeStyles({
    root: {
      width: 'auto',
      height:'auto',
      textAlign:'center',
      '& h6':{
          color:'#0a0e51',
          'font-family': 'Nunito',
          'font-size':'16px',
          'margin-bottom':'1px',
          'margin-top':'5px'
      },
      '& h7':{
          color:'#0a0e51',
          'font-family': 'Nunito',
          'font-size':'19px',
          'padding-top': '20px',
          
      } 
   
  
    }
   
  
  });
  const GreenRadio = withStyles({
    root: {
      color:'#0a0e51',
      '&$checked': {
        color:'#0a0e51',
      },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);
